<template>
  <footer id="u-client-footer" class="has-inset-shadow-top">
    <powered-by-upmind class="is-size-7 has-text-centered" />
  </footer>
</template>

<script>
export default {
  name: "ClientFooter",
  components: {
    "powered-by-upmind": () => import("@/skeleton/poweredByUpmind.vue")
  }
};
</script>

<style lang="scss" scoped>
footer#u-client-footer {
  margin-top: auto;
  padding: 1.5rem;
  background-color: $primary;
  background-color: var(--brand-color);
}
</style>
